module.exports = __webpack_public_path__ + "static/media/graduation.25cd60c6.jpg";